<div class="tree-item-picker-field">
    <div class="label-container">
        <cerrix-label [for]="name">{{ label }}</cerrix-label>
        @if (infoText) {
            <cerrix-instructions-icon
                class="input-instructions-icon"
                [instructionText]="infoText"
                [showText]="false"
            ></cerrix-instructions-icon>
        }
    </div>
    <app-cerrix-picker-field
        validationErrors
        [name]="name"
        [text]="selectedItemsDescription()"
        [placeholder]="placeholder"
        (pressed)="openDialog()"
    ></app-cerrix-picker-field>
</div>

<cerrix-dialog [name]="dialogName" (closed)="validationTouched.next()">
    <div header-title>{{ dialogTitle }}</div>
    <div class="tree-item-picker-dialog-content" dialog-content>
        <div class="toolbar">
            <cerrix-search-input
                [placeholder]="'cerrix-tree-item-picker.searchPlaceholder' | transloco"
                [value]="filter"
                (valueChange)="onFilterChange($event)"
            ></cerrix-search-input>
            <button
                type="button"
                (click)="expandAll()"
                [matTooltip]="'cerrix-tree-item-picker.expandAllTooltip' | transloco"
            >
                <mat-icon svgIcon="open-list"></mat-icon>
            </button>
            @if (multiselect) {
                <button
                    type="button"
                    (click)="selectAll()"
                    [matTooltip]="'cerrix-tree-item-picker.selectAllTooltip' | transloco"
                >
                    <mat-icon svgIcon="multiselect"></mat-icon>
                </button>
            }
            <button
                type="button"
                [class.active]="showSelectedOnly"
                (click)="toggleShowSelectedOnly()"
                [matTooltip]="'cerrix-tree-item-picker.showSelectedTooltip' | transloco"
            >
                <mat-icon svgIcon="show"></mat-icon>
            </button>
            @if (multiselect) {
                <div class="divider"></div>
                <app-cerrix-checkbox
                    [value]="includeChildren"
                    (valueChange)="toggleIncludeChildren($event)"
                    >{{
                        "cerrix-tree-item-picker.includeChildrenLabel" | transloco
                    }}</app-cerrix-checkbox
                >
            }
        </div>
        <app-cerrix-select-tree
            #selectTree
            [items]="items"
            [selectedIds]="draftSelection"
            (selectionChanged)="updateDraftSelection($event)"
            [iconPrefix]="iconPrefix"
            [multiselect]="multiselect"
            [includeChildren]="includeChildren"
            [showSelectedOnly]="showSelectedOnly"
            [filter]="filter"
        ></app-cerrix-select-tree>
    </div>
    <div class="tree-item-picker-dialog-footer" dialog-footer>
        <cerrix-button
            buttonType="secondary"
            secondaryColor="filled"
            buttonSize="big"
            (click)="cancelSelection()"
            >{{ "cerrix-tree-item-picker.cancel" | transloco }}</cerrix-button
        >
        <cerrix-button buttonSize="big" primaryColor="green" (click)="confirmSelection()">
            {{ confirmButtonLabelKey | transloco }}</cerrix-button
        >
    </div>
</cerrix-dialog>
